import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AnimationClassNames, MessageBar, MessageBarType, PrimaryButton, Spinner, Stack, } from '@fluentui/react';
/**
 * Canned form submission button with error bar and loader.
 */
export const SubmitButton = ({ disabled = false, errorMessage, form, isSubmitting = false, submittingMessage, iconName = 'Send', }) => {
    const spinnerLabel = submittingMessage || 'Your report is being submitted';
    return (_jsxs(Stack, Object.assign({ horizontal: true, horizontalAlign: 'stretch', tokens: { childrenGap: '12px' }, styles: { root: { width: '100%' } } }, { children: [_jsx(PrimaryButton, Object.assign({ styles: {
                    flexContainer: {
                        flexDirection: 'row-reverse',
                    },
                }, form: form, type: 'submit', disabled: isSubmitting || disabled, iconProps: { iconName } }, { children: "Submit" })), isSubmitting && (_jsx(Spinner, { ariaLabel: spinnerLabel, label: spinnerLabel, labelPosition: 'right', styles: {
                    root: {
                        display: 'inline-flex',
                        placeItems: 'center',
                        flexGrow: 1,
                    },
                } })), !isSubmitting && errorMessage && (_jsx(MessageBar, Object.assign({ messageBarType: MessageBarType.error, role: 'alert', className: AnimationClassNames.fadeIn100, styles: {
                    root: {
                        width: 'auto',
                        flexGrow: 1,
                    },
                } }, { children: errorMessage })))] })));
};
